module.exports = __webpack_public_path__ + "img/sac-pharmacie.99637eed.jpg";